import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PlusIcon } from '@heroicons/react/24/outline';
import { twMerge } from 'tailwind-merge';

type SeeAllUnitsCardProps = {
  href: string;
  className?: string;
};

export default function SeeAllUnitsCard({
  href,
  className,
}: SeeAllUnitsCardProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'studentDashboard.courseTrack',
  });

  return (
    <Link
      to={href}
      className={twMerge(
        'flex h-full w-full flex-col items-center justify-center gap-6 rounded-3xl bg-base-200 p-6 text-base-content transition-[filter] hover:brightness-95',
        className,
      )}
    >
      <PlusIcon className="size-16" />
      <span className="text-center text-base">{t('seeAllUnits')}</span>
    </Link>
  );
}
